export default function generateDisplayName(givenName, surname) {
  var displayName = "";
  if (givenName && surname) {
    displayName = surname.toUpperCase() + " " + givenName[0].toUpperCase() + givenName.substring(1);;
  }
  return displayName;
}
